(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jaxie-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const openGuideFromHash = () => {
    if (window.location.hash !== '#jaxie-size-guide') return;
    const guide = document.getElementById('jaxie-size-guide');
    if (guide) guide.open = true;
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-jaxie-size-guide]');
    if (!link || link.hash !== '#jaxie-size-guide') return;
    const guide = document.getElementById('jaxie-size-guide');
    if (guide) guide.open = true;
  });
  window.addEventListener('hashchange', openGuideFromHash);
  document.addEventListener('DOMContentLoaded', openGuideFromHash);
  openGuideFromHash();
  /* Clickable carousel arrows while keeping swipe and scroll on mobile. */
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-jx-carousel-step]') : null;
    if (!target) return;
    const carousel = target.closest('.jx-products')?.querySelector('.jx-product-grid');
    if (!carousel) return;
    const distance = (carousel.querySelector('.jx-product')?.getBoundingClientRect().width || 205) + 14;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    carousel.scrollBy({left: distance * Number(target.dataset.jxCarouselStep || 1), behavior: smooth ? 'smooth' : 'auto'});
  });
  /* One delegated listener keeps the gallery working after Shopify theme editor reloads. */
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const dialog = document.querySelector('[data-jaxie-lightbox]');
    if (!dialog) return;
    const opener = event.target.closest('[data-jaxie-gallery-open]');
    if (opener) {
      const card = opener.closest('.jx-moment__switch');
      const isBack = Boolean(card?.querySelector('.jx-moment__radio--back:checked'));
      const source = (isBack ? opener.dataset.photoBack : opener.dataset.photoFront) || opener.dataset.photoFront;
      if (!source) return;
      const img = dialog.querySelector('[data-jaxie-lightbox-image]');
      const caption = dialog.querySelector('[data-jaxie-lightbox-caption]');
      const name = opener.dataset.title || 'JAXIE';
      img.src = source;
      img.alt = name + (isBack ? ' back view' : ' front view');
      caption.textContent = name;
      if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    if (event.target.closest('[data-jaxie-lightbox-close]') || event.target === dialog) {
      if (dialog.open) dialog.close();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
